<template>
  <div>
    <b-field class="mt-4">
      <b-button type="is-danger" :loading="loading" :disabled="loading" @click="submit">
        Supprimer la sélection
      </b-button>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'LiveStagePathForm',

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    disabledSubmit() {
      return this.loading
    },
  },

  methods: {
    submit() {
      this.$emit('delete')
    },
  },
}
</script>
